import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-research-funding-agencies',
  templateUrl: './research-funding-agencies.component.html',
  styleUrls: ['./research-funding-agencies.component.scss']
})
export class ResearchFundingAgenciesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
